/**
 * @generated SignedSource<<14bfab76f64eb34ef56a287105904731>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type BlogSubcategory_User$data = {
  readonly " $fragmentSpreads": FragmentRefs<"user_useIsGuest">;
  readonly " $fragmentType": "BlogSubcategory_User";
};
export type BlogSubcategory_User$key = {
  readonly " $data"?: BlogSubcategory_User$data;
  readonly " $fragmentSpreads": FragmentRefs<"BlogSubcategory_User">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "BlogSubcategory_User",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "user_useIsGuest"
    }
  ],
  "type": "User",
  "abstractKey": null
};

(node as any).hash = "6a6aca448432ae491b59c52e29daa7de";

export default node;
